module.exports = __webpack_public_path__ + "img/oral-icon.cfd88c6b.svg";